import * as React from "react";
import {
  Create,
  SimpleForm,
  SelectInput,
  required,
  ReferenceInput,
  NumberInput,
  AutocompleteInput,
  useGetList,
  BooleanInput,
  minValue,
  maxValue,
} from "react-admin";
import { GAS_BRAND_MERCHANT_STATUSES } from "@local/app/constants/index.js";
import { CustomToolbar } from "../../shared/components/index.js";

const GasBrands = (merchant) => {
  const { merchant: targetMerchant } = merchant;

  if (targetMerchant) {
    const { data: images } = useGetList("File", {
      filter: {
        account_id: targetMerchant,
      },
    });

    const renderOptionText = (record) => {
      const [logo] = images.filter((image) => {
        if (record.logo_file_id === image.id) {
          return image;
        }
      });

      return (
        <span key={record.id}>
          <img
            src={logo?.url}
            width={15}
            height={15}
            style={{ marginRight: "5px" }}
          />
          {record.name}
        </span>
      );
    };

    return (
      <ReferenceInput source="gas_brand_id" reference="GasBrand">
        <AutocompleteInput
          sx={{ width: "14%" }}
          inputText={(record) => record.name}
          optionText={renderOptionText}
          optionValue="id"
          debounce={10}
          validate={[required()]}
          filterToQuery={(searchText) => ({ name: searchText })}
        />
      </ReferenceInput>
    );
  }
};

const createGasBrandMerchant = () => {
  const [selectedMerchant, serSelectedMerchant] = React.useState(null);

  const handleMerchant = (event) => {
    serSelectedMerchant(event.target.value);
  };

  const renderOptionText = (record) => {
    return (
      <span key={record.id}>
        <img
          src={record?.url}
          alt={record.name}
          width={15}
          height={15}
          style={{ marginRight: "5px" }}
        />
        {record.name}
      </span>
    );
  };

  return (
    <Create redirect="show">
      <SimpleForm toolbar={<CustomToolbar />}>
        <ReferenceInput source="merchant_id" reference="Merchant">
          <SelectInput
            optionText="name"
            optionValue="id"
            validate={[required()]}
            onChange={handleMerchant}
          />
        </ReferenceInput>
        <GasBrands merchant={selectedMerchant} />
        <ReferenceInput source="logo_file_id" reference="File">
          <AutocompleteInput
            inputText={(record) => record.name}
            optionText={renderOptionText}
            optionValue="id"
            debounce={10}
            filterToQuery={(searchText) => ({ name: searchText })}
          />
        </ReferenceInput>
        <NumberInput
          sx={{ width: "14%" }}
          source="priority"
          min={0}
          max={32000}
          validate={[required(), minValue(0), maxValue(32000)]}
          defaultValue={0}
        />
        <BooleanInput source="partner_gas_brand" />
        <SelectInput
          source="status"
          validate={[required()]}
          choices={Object.keys(GAS_BRAND_MERCHANT_STATUSES).map((status) => ({
            id: status,
            name: `resources.GasBrandMerchant.source.status.${status}`,
          }))}
        />
      </SimpleForm>
    </Create>
  );
};

export default createGasBrandMerchant;
